import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "detail" }
const _hoisted_2 = ["innerHTML"]


import { ElButton } from "element-plus";
import { isTestEnv } from "../utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'detail-collapse',
  props: {
    text: {},
    name: {},
    id: {}
  },
  setup(__props: any) {

const props = __props;

const toApplication = () => {
  const link = `https://www${isTestEnv() ? "-uat" : ""}.ky-express.com/219.html?id=${
    props.id
  }&name=${encodeURI(props.name)}`;
  if (window.self !== window.top) {
    window.top.location.href = link;
  } else {
    window.open(link, "_self");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      innerHTML: props.text
    }, null, 8, _hoisted_2),
    _createVNode(_unref(ElButton), {
      class: "application-btn",
      onClick: toApplication
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("立即申请")
      ])),
      _: 1
    })
  ]))
}
}

})